import store from '../../store/index';
import captureRenderBlockingException from '../../tracking/helpers/captureRenderBlockingException';
import tagRecordings from '../../tracking/hotjar/tagRecordings';

function generateExtras() {
  let loanOffers = null;
  const { loanApplication } = store.state;
  const { quotes } = loanApplication;
  if (typeof quotes !== 'undefined' && quotes !== null) {
    loanOffers = quotes;
  }
  const extras = {
    loanApplication,
    loanOffers,
    sessionQuote: store.state.sessionQuote,
  };

  return extras;
}

export default async function beforeEnterLoanOffers(to, from, next) {
  try {
    const completed = await store.dispatch('canEnterLoanOffers');
    if (completed === 'redirect') {
      return;
    }

    if (!completed) {
      tagRecordings(['cannot_enter_reg4']);
      next('/v/pessoal');
      return;
    }
  } catch (e) {
    store.dispatch('setBackendErrorMessage');
    captureRenderBlockingException(e, generateExtras());
    window.location.href = '/account_home';
  } finally {
    store.dispatch('setAwaitingNavigation', false);
  }

  next();
}
